module.exports = __webpack_public_path__ + "89df5620a87707e48c5d65be7d1165d0.png";